import Repository from '../Repository';
import store from "../../store/store";

const url = '';

export default {
    getSanctumCSRFCookie() {
        return Repository.get(`${url}/csrf-cookie`, {fullPageLoading: true});
    },

    login(payload) {
        return Repository.post(`${url}/login`, payload, {fullPageLoading: true});
    },

    logout() {
        return Repository.post(`${url}/logout`, null, {fullPageLoading: true});
    },

    requestPasswordResetMail(email) {
        return Repository.post(`${url}/password-reset/request`, {email: email}, {fullPageLoading: true});
    },

    checkPasswordResetToken(token) {
        return Repository.post(`${url}/password-reset/check`, {token: token}, {fullPageLoading: true});
    },

    resetPassword(token, payload) {
        return Repository.post(`${url}/password-reset/${token}`, payload, {fullPageLoading: true});
    },

    createAccount(payload) {
        return Repository.post(`${url}/register`, payload, {fullPageLoading: true});
    },

    fetchAuthDetails(shouldShowLoadingIndicator = false) {
        return Repository.get(`${url}/auth`, {dont_append_to_loading_stack: !shouldShowLoadingIndicator})
            .then((res) => {
                store.commit('setAuthInfo', res.data)
            });
    }

}
